var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_509_2",
    "data-name": "Component 509 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13755",
    "data-name": "Rectangle 13755",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list-text",
    transform: "translate(0.999 -76.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33642",
    "data-name": "Group 33642",
    transform: "translate(3.381 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33641",
    "data-name": "Group 33641",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40395",
    "data-name": "Path 40395",
    d: "M108.551,80H97.3a1.125,1.125,0,1,0,0,2.249h11.246a1.125,1.125,0,0,0,0-2.249Z",
    transform: "translate(-96.18 -80)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33644",
    "data-name": "Group 33644",
    transform: "translate(0.001 80.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33643",
    "data-name": "Group 33643",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40396",
    "data-name": "Path 40396",
    d: "M2.256,81.255a1.125,1.125,0,0,0-2.249,0,.958.958,0,0,0,0,.219,1.016,1.016,0,0,0,.062.214,1.3,1.3,0,0,0,.107.191,1.023,1.023,0,0,0,.141.174,1,1,0,0,0,.169.135.918.918,0,0,0,.191.107.933.933,0,0,0,.236.084,1,1,0,0,0,.219,0,1.125,1.125,0,0,0,.793-.326,1.023,1.023,0,0,0,.141-.174,1.3,1.3,0,0,0,.107-.191,1.046,1.046,0,0,0,.084-.214A.958.958,0,0,0,2.256,81.255Z",
    transform: "translate(-0.001 -80.135)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33646",
    "data-name": "Group 33646",
    transform: "translate(0.007 85.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33645",
    "data-name": "Group 33645",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40397",
    "data-name": "Path 40397",
    d: "M2.429,225.255a.961.961,0,0,0,0-.219.909.909,0,0,0-.084-.208,1.109,1.109,0,0,0-.107-.2.8.8,0,0,0-.141-.168,1.125,1.125,0,0,0-1.917.793,1.246,1.246,0,0,0,.084.433,1.245,1.245,0,0,0,.1.191,1.072,1.072,0,0,0,.146.169.813.813,0,0,0,.169.141.912.912,0,0,0,.191.107.957.957,0,0,0,.214.062.933.933,0,0,0,.219.022.941.941,0,0,0,.219,0,.91.91,0,0,0,.208-.062.943.943,0,0,0,.2-.107.813.813,0,0,0,.169-.141.817.817,0,0,0,.141-.168.907.907,0,0,0,.107-.191.951.951,0,0,0,.084-.236A.93.93,0,0,0,2.429,225.255Z",
    transform: "translate(-0.18 -224.135)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33648",
    "data-name": "Group 33648",
    transform: "translate(0.007 90.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33647",
    "data-name": "Group 33647",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40398",
    "data-name": "Path 40398",
    d: "M2.427,369.255a.965.965,0,0,0,0-.219.945.945,0,0,0-.084-.213,1.289,1.289,0,0,0-.107-.191.8.8,0,0,0-.141-.168,1.124,1.124,0,0,0-1.586,0,.8.8,0,0,0-.141.168,1.288,1.288,0,0,0-.107.191.907.907,0,0,0-.062.213.967.967,0,0,0-.022.219,1.123,1.123,0,0,0,.332.792.791.791,0,0,0,.169.141.925.925,0,0,0,.191.107.983.983,0,0,0,.214.062.92.92,0,0,0,.219.022.915.915,0,0,0,.219,0,.934.934,0,0,0,.208-.062.966.966,0,0,0,.2-.107.821.821,0,0,0,.169-.141.82.82,0,0,0,.141-.169.884.884,0,0,0,.107-.191.95.95,0,0,0,.084-.236A.93.93,0,0,0,2.427,369.255Z",
    transform: "translate(-0.178 -368.135)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33650",
    "data-name": "Group 33650",
    transform: "translate(3.381 85.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33649",
    "data-name": "Group 33649",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40399",
    "data-name": "Path 40399",
    d: "M109.675,224H97.3a1.125,1.125,0,1,0,0,2.249h12.37a1.125,1.125,0,1,0,0-2.249Z",
    transform: "translate(-96.18 -224)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33652",
    "data-name": "Group 33652",
    transform: "translate(3.381 90.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33651",
    "data-name": "Group 33651",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40400",
    "data-name": "Path 40400",
    d: "M104.615,368H97.3a1.125,1.125,0,1,0,0,2.249h7.31a1.125,1.125,0,1,0,0-2.249Z",
    transform: "translate(-96.18 -368)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.6b31e185.svg";
export { ForwardRef as ReactComponent };